<table class="tiime-table" aria-label="Tableau pièces jointes">
  <thead>
    <tr tiimeTableHeaderRow>
      <th tiimeTableHeaderCell="sentLastSignature"></th>
      <th tiimeTableHeaderCell="name">Nom du fichier</th>
      <th class="align-column-with-input-value" tiimeTableHeaderCell="title">Titre</th>
      <th tiimeTableHeaderCell="type">Type</th>
      <th tiimeTableHeaderCell="actions"></th>
    </tr>
  </thead>
  <tbody>
    @for (fileForm of filesForms; track i; let i = $index) {
      <tr tiimeTableRow [formGroup]="fileForm">
        <td tiimeTableCell="sentLastSignature">
          @if (fileForm.sentLastSignature.value && contractStatus() !== ContractStatus.draft) {
            <mat-icon [tiimeTooltip]="sentLastSignatureTooltip()">
              {{ sentLastSignatureIcon() }}
            </mat-icon>
          }
        </td>
        <td tiimeTableCell="name">
          <app-simple-cell [value]="fileForm.name.value"></app-simple-cell>
        </td>
        <td tiimeTableCell="title">
          @if (fileForm.content.value) {
            <input type="text" placeholder="Titre" formControlName="title" />
          } @else {
            <app-simple-cell class="align-column-with-input-value" [value]="fileForm.title.value" />
          }
        </td>
        <td tiimeTableCell="type">
          <app-simple-cell [value]="fileForm.type.value | codeAndLabel: fileTypes()" />
        </td>
        <td class="show-on-hover" tiimeTableCell="actions">
          <button
            type="button"
            tiime-button
            color="primary"
            tabindex="-1"
            icon
            [disabled]="!fileForm.id.value || (fileForm.contractOffer.value && !fileForm.contractOffer.value?.id)"
            [tiimeTooltip]="
              !fileForm.id.value || (fileForm.contractOffer.value && !fileForm.contractOffer.value?.id)
                ? 'Veuillez enregistrer pour pouvoir télécharger la pièce jointe'
                : 'Télécharger la pièce jointe'
            "
            (click)="emitDownloadFile(fileForm.id.value)"
          >
            <mat-icon inline="true" fontSet="fontastic" fontIcon="icon-download-24"></mat-icon>
          </button>
          <button
            type="button"
            tiime-button
            color="primary"
            tabindex="-1"
            icon
            [disabled]="!fileForm.id.value || (fileForm.contractOffer.value && !fileForm.contractOffer.value?.id)"
            [tiimeTooltip]="
              !fileForm.id.value || (fileForm.contractOffer.value && !fileForm.contractOffer.value?.id)
                ? 'Veuillez enregistrer pour pouvoir ouvrir la pièce jointe dans un nouvel onglet'
                : 'Ouvrir la pièce jointe dans un nouvel onglet'
            "
            (click)="emitOpenFileInNewTab(fileForm.id.value)"
          >
            <mat-icon inline="true" fontSet="fontastic" fontIcon="icon-open-in-new-window-2"></mat-icon>
          </button>
          <button
            type="button"
            tiime-button
            icon
            color="primary"
            tabindex="-1"
            tiimeTooltip="Retirer la pièce jointe"
            [disabled]="fileForm.disabled"
            (click)="emitRemoveFile(i)"
          >
            <mat-icon fontSet="fontastic" fontIcon="icon-ic-remove"></mat-icon>
          </button>
        </td>
      </tr>
    }
  </tbody>
</table>
